import { proctoringUBALogger } from './trackingUtil';

export const isAndroidWebview = () => {
  proctoringUBALogger(
    'Android Webview',
    `checking if device is android webview ${window.JSUtilityInterface?.isWebView}`
  );
  return (
    typeof window.JSUtilityInterface !== 'undefined' &&
    !!window.JSUtilityInterface.isWebView
  );
};

/**
 * This function is responsible for removing the callback that is called when the permission retry limit is reached.
 * This is specifically useful for Android Webview where we have a retry limit of 2 for permission requests.
 * After the limit is reached, the user needs to be informed to manually allow permissions from settings.
 * @returns void
 */
export const removeOnPermissionRetryLimitReached = () => {
  proctoringUBALogger(
    'Android Webview',
    'removing onPermissionRetryLimitReached callback'
  );
  window.onPermissionRetryLimitReached = null;
};

/**
 * This function is responsible for adding a callback that will be called when the permission retry limit is reached.
 * This is specifically useful for Android Webview where we have a retry limit of 2 for permission requests.
 * After the limit is reached, the user needs to be informed to manually allow permissions from settings.
 * @param {*} onPermissionLimitReached - Callback function to be called when permission retry limit is reached.
 */
export const addOnPermissionRetryLimitReached = onPermissionLimitReached => {
  proctoringUBALogger(
    'Android Webview',
    'adding onPermissionRetryLimitReached callback'
  );
  window.onPermissionRetryLimitReached = () => {
    proctoringUBALogger('Android Webview', 'permission retry limit reached');
    removeOnPermissionRetryLimitReached();
    onPermissionLimitReached?.();
  };
};

export const requestAudioVideoPermission = async ({
  constraints = { audio: true, video: true },
  onException,
  onPermissionAllowed,
  onPermissionDenied,
  onAudioTrackEnded,
  onVideoTrackEnded,
}) => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    onException?.(null);
    onPermissionAllowed?.();

    const listeners = [];

    stream.getAudioTracks().forEach(audioTrack => {
      const handler = () => {
        onException?.(webcamDomException.NotAllowedError);
        onAudioTrackEnded?.();
      };
      audioTrack.addEventListener('ended', handler);
      listeners.push({ track: audioTrack, handler });
    });

    stream.getVideoTracks().forEach(videoTrack => {
      const handler = () => {
        onException?.(webcamDomException.NotAllowedError);
        onVideoTrackEnded?.();
      };
      videoTrack.addEventListener('ended', handler);
      listeners.push({ track: videoTrack, handler });
    });

    const cleanup = () => {
      listeners.forEach(({ track, handler }) => {
        track.removeEventListener('ended', handler);
      });
      stream.getTracks().forEach(track => track.stop());
    };

    return { stream, cleanup };
  } catch (err) {
    onPermissionDenied?.(err);
    onException?.(err.name || err);

    return { stream: null, cleanup: () => {} };
  }
};
